"use client";

// src/components/text/index.tsx
import React from "react";
import { textRecipe } from "@pinatagrams/design-system/recipes";
import { jsx } from "react/jsx-runtime";
var Title = React.forwardRef(
  ({ hierarchy = "title", emphasis = "strong", className, children, ...props }, ref) => {
    const slots = textRecipe({ hierarchy, titleEmphasis: emphasis });
    const cls = slots.title;
    const Tag = hierarchy === "splash" ? "h1" : hierarchy === "subtitle" ? "h3" : "h2";
    return (
      // @ts-expect-error dynamic heading tag
      /* @__PURE__ */ jsx(Tag, { ref, className: [cls, className].filter(Boolean).join(" "), ...props, children })
    );
  }
);
Title.displayName = "Title";
var Body = React.forwardRef(
  ({ emphasis = "DEFAULT", className, children, ...props }, ref) => {
    const slots = textRecipe({ bodyEmphasis: emphasis });
    const cls = slots.body;
    return /* @__PURE__ */ jsx("p", { ref, className: [cls, className].filter(Boolean).join(" "), ...props, children });
  }
);
Body.displayName = "Body";
var Supplemental = React.forwardRef(
  ({ emphasis = "DEFAULT", className, children, ...props }, ref) => {
    const slots = textRecipe({ supplementalEmphasis: emphasis });
    const cls = slots.supplemental;
    return /* @__PURE__ */ jsx(
      "code",
      {
        ref,
        className: [cls, className].filter(Boolean).join(" "),
        ...props,
        children
      }
    );
  }
);
Supplemental.displayName = "Supplemental";
var text_default = Title;
export {
  Body,
  Supplemental,
  Title,
  text_default as default
};
//# sourceMappingURL=text.js.map